export const PIPELINE_STAGE = {
  preparation: "PREPARATION",
  detector: "DETECTOR",
  tracker: "TRACKER",
  resolveTrackConflict: "RESOLVE_TRACK_CONFLICT",
  ballSupertrack: "BALL_SUPER_TRACK",
  superTracks: "SUPER_TRACKS",
  creationFinalJson: "CREATION_FINAL_JSON",
  eventConflict: "EVENT_CONFLICT",
  eventValidation: "EVENT_VALIDATION",
  matchEvent: "MATCH_EVENT",
  eventTagging: "EVENT_TAGGING",
  done: "DONE",
};

export const STAGE_STATUSES_TEXT = {
  [PIPELINE_STAGE.preparation]: "Preprocessing",
  [PIPELINE_STAGE.detector]: "Detection",
  [PIPELINE_STAGE.tracker]: "Tracking",
  [PIPELINE_STAGE.ballSupertrack]: "Ball Markup",
  [PIPELINE_STAGE.superTracks]: "Compilation of super tracks",
  [PIPELINE_STAGE.creationFinalJson]: "Creating the final file for processing",
  [PIPELINE_STAGE.ballTouch]: "Manual Ball Touch",
  [PIPELINE_STAGE.eventConflict]: "Manual event marking",
  [PIPELINE_STAGE.eventValidation]: "Manual event validation",
  [PIPELINE_STAGE.matchEvent]: "Match Event",
  [PIPELINE_STAGE.eventTagging]: "Event Tagging",
  [PIPELINE_STAGE.done]: "Ready",
};
